import { EmptyState as ChakraEmptyState, VStack, type StackProps } from 'chakra-ui-next'
import * as React from 'react'

export interface EmptyStateProps extends ChakraEmptyState.RootProps {
  title: string
  description?: string
  icon?: React.ReactNode

  iconProps?: StackProps
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  function EmptyState(props, ref) {
    const { title, description, icon, children, iconProps, ...rest } = props
    return (
      <ChakraEmptyState.Root ref={ref} {...rest}>
        <ChakraEmptyState.Content gap={6}>
          {icon && (
            <ChakraEmptyState.Indicator>
              <VStack w="6" h="6" color="fg.muted" {...iconProps}>
                {icon}
              </VStack>
            </ChakraEmptyState.Indicator>
          )}

          {description ? (
            <VStack textAlign="center">
              <ChakraEmptyState.Title mb="1">{title}</ChakraEmptyState.Title>
              <ChakraEmptyState.Description>{description}</ChakraEmptyState.Description>
            </VStack>
          ) : (
            <ChakraEmptyState.Title fontWeight={'medium'}>{title}</ChakraEmptyState.Title>
          )}
          {children}
        </ChakraEmptyState.Content>
      </ChakraEmptyState.Root>
    )
  },
)
